import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  for: "srh__input",
  class: "sr-only"
}
const _hoisted_3 = ["maxlength", "value", "placeholder"]

import { ref, Ref, onMounted, watch } from "vue";
import useSearch from "@/composables/use-search";
import useDepartment from "@/composables/use-department";
import { isClassicSite, language } from "@ocm/services/ocm-object";
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import { useDebounceFn, useFocus, useSpeechRecognition } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchForm',
  setup(__props) {

const { departmentCapitalized } = useDepartment();
const {
	userInput,
	userInputMaxlength,
	setInputElementRef,
	triggerTypeAhead,
	openSearch,
	triggerSearch,
	deleteSearch,
	isSearchVisible,
	setUserInput,
} = useSearch();

const inputEl: Ref<HTMLInputElement | null> = ref(null);
const { focused } = useFocus(inputEl);

onMounted(() => {
	setInputElementRef(inputEl.value);
});

const setInputFocus = () => {
	inputEl.value?.focus();
};

const _debounceSearch = useDebounceFn(triggerSearch, 600);
const speech = useSpeechRecognition({ lang: language, interimResults: false });
const { isListening, isSupported: isSpeechSupported } = speech;
const triggerSpeech = () => speech.toggle(!isListening.value);
watch(speech.result, (result) => {
	speech.stop();
	userInput.value = result;
	_debounceSearch("voice");
});

const placeholderI18n = new Map([
	["ar", "بحث"],
	["de", "Suche"],
	["en", "Search"],
	["fr", "Chercher"],
	["ko", "검색"],
	["ru", "Поиск"],
	["zh", "搜索"],
]);
const placeholderClassic = placeholderI18n.get(language);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "grid h-10 cursor-text grid-cols-[1.4285714rem_1fr_1.7142857rem] gap-x-2 rounded-full bg-gray-20 px-8 text-gray-80 focus-within:bg-gray-40 focus-within:text-black hover:bg-gray-40",
    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (!_unref(focused) && setInputFocus()), ["self"])),
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "grid place-content-center text-inherit",
      disabled: !_unref(isSearchVisible) || !_unref(userInput).length,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(triggerSearch)('click')))
    }, [
      _createVNode(SvgIcon, {
        "icon-name": "magnifying-glass",
        class: "h-5 w-5"
      })
    ], 8, _hoisted_1),
    _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(isClassicSite) ? _unref(placeholderClassic) : "Artikel suchen"), 1),
    _createElementVNode("input", {
      id: "srh__input",
      ref_key: "inputEl",
      ref: inputEl,
      type: "text",
      class: "bg-transparent text-base placeholder:text-gray-80",
      maxlength: _unref(userInputMaxlength),
      value: _unref(userInput),
      placeholder: 
				_unref(isListening) ? 'Was suchen Sie?' : _unref(isClassicSite) ? _unref(placeholderClassic) : `Suche in: ${_unref(departmentCapitalized)}`
			,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(setUserInput)(($event.target as HTMLInputElement).value))),
      onKeyup: [
        _cache[2] || (_cache[2] = ($event: any) => (_unref(triggerTypeAhead)())),
        _cache[3] || (_cache[3] = _withKeys(($event: any) => (_unref(triggerSearch)('keyboard')), ["enter"]))
      ],
      onFocus: _cache[4] || (_cache[4] = ($event: any) => (_unref(openSearch)()))
    }, null, 40, _hoisted_3),
    (_unref(isSpeechSupported) && !_unref(userInput).length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(["grid place-content-center rounded-xl", _unref(isListening) ? 'srh__bg-pulse text-white' : 'text-gray-80 hover:text-black']),
          onClick: triggerSpeech
        }, [
          _createVNode(SvgIcon, {
            "icon-name": "mic",
            class: "h-5 w-5"
          })
        ], 2))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: _normalizeClass(["grid place-content-center", { invisible: !_unref(isSearchVisible) || !_unref(userInput).length }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(deleteSearch)()))
        }, [
          _createVNode(SvgIcon, {
            "icon-name": "close-new",
            class: "h-5 w-5"
          })
        ], 2))
  ], 32))
}
}

})